module.exports = __webpack_public_path__ + "static/media/box-number-lose.390ac0d5.png";